import { NgModule } from "@angular/core";
import { InfoIconHoverableComponent } from "./info-icon-hoverable.component";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { WsTooltipModule } from "@web/util/ws-ui/ws-tooltip/ws-tooltip.module";


@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    WsTooltipModule,
  ],
  declarations: [InfoIconHoverableComponent],
  exports: [InfoIconHoverableComponent]
})
export class InfoIconHoverableModule { }
